import { Link } from 'react-router-dom';
import type { Moment } from '@/mocks/moments';
import { formatCount } from '@/utils/format';

interface MomentCardProps {
  moment: Moment;
}

export default function MomentCard({ moment }: MomentCardProps) {
  return (
    <article className="group flex flex-col rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors">
      <Link to={`/moment/${moment.id}`} className="block cursor-pointer">
        <div className="relative w-full h-48 sm:h-52 overflow-hidden bg-background-200">
          <img
            src={moment.cover}
            alt={`${moment.title} 封面图`}
            title={`${moment.title} · 私拍吃瓜名场面`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <span className="absolute top-3 left-3 px-3 py-1 rounded-full text-xs bg-background-50/95 text-primary-800">
            {moment.category}
          </span>
        </div>
      </Link>

      <div className="flex flex-col flex-1 p-5">
        <h3 className="font-heading text-lg leading-snug text-foreground-950">
          <Link to={`/moment/${moment.id}`} className="cursor-pointer hover:text-primary-700 transition-colors">
            {moment.title}
          </Link>
        </h3>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 line-clamp-3">{moment.summary}</p>

        <div className="mt-4 flex flex-wrap gap-2">
          {moment.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="px-2.5 py-1 rounded-md text-xs bg-secondary-100 text-secondary-900">
              {tag}
            </span>
          ))}
        </div>

        <div className="mt-5 pt-4 border-t border-background-200 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-4">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {formatCount(moment.views)}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-heart-3-line"></i>
              {formatCount(moment.likes)}
            </span>
          </span>
          <span className="flex items-center gap-1 text-foreground-400">
            <i className="ri-calendar-line"></i>
            {moment.date}
          </span>
        </div>
      </div>
    </article>
  );
}